export default __webpack_public_path__ + "static/media/EasternPassMap.d22c93c5.jpg";